import * as React from 'react';

import { Input } from 'src/registry/ui/Input';
import { cn } from 'src/utils/shadcn';

function InputWithInlineTitle({
    className,
    inlineTitle,
    wrapperProps,
    'aria-invalid': ariaInvalid,
    ...props
}: React.ComponentProps<typeof Input> & { wrapperProps?: React.ComponentProps<'div'>; inlineTitle: string }) {
    const { className: wrapperClassName } = wrapperProps || {};

    return (
        <div className={cn('group relative', wrapperClassName)} {...wrapperProps}>
            <div
                aria-invalid={ariaInvalid}
                className="border-border aria-invalid:border-destructive text-muted-foreground absolute top-1/2 left-0 flex h-full min-w-14 -translate-y-1/2 items-center justify-center border-r"
            >
                {inlineTitle}
            </div>
            <Input className={cn('pl-16', className)} aria-invalid={ariaInvalid} {...props} />
        </div>
    );
}

export { InputWithInlineTitle };
